import { Version } from "./version";


export const FUSE_VERSION = new Version('20.0.0').full;
